export class AssetsPoUnitRequest {
    unitId: number;
  }